<ng-container *transloco="let t; read: 'caller-info-dialog'">
  <p-toast position="bottom-center"></p-toast>

  <legend>
    {{ t('dialogHeader') }}
  </legend>

  <app-progress-spinner *ngIf="loading"></app-progress-spinner>

  <div *ngIf="!loading && communicationsResponseGetCallLogPII?.getError() !== undefined">
    {{ t('nothingToShow') }}
  </div>

  <div *ngIf="!loading && communicationsResponseGetCallLogPII?.getError() === undefined">
    <!-- Phone Number -->
    <div class="field grid">
      <label class="caller-info-dialog__field-label" for="e164Phone" style="width: 200px">
        {{ t('e164PhoneLabel') }}
        <i
          aria-hidden="true"
          class="pi pi-question-circle caller-info-dialog__tooltip-icon"
          tooltipPosition="right"
          [pTooltip]="t('e164PhoneTooltip')"
          [tooltipStyleClass]="'p-tooltip--large'"
        ></i>
      </label>
      <div class="col">
        <input
          class="full-width"
          id="e164Phone"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetCallLogPII?.getCallerPhone() }}"
        />
      </div>
    </div>

    <!-- Caller Name -->
    <div class="field grid">
      <label for="callerName" style="width: 200px">{{ t('callerNameLabel') }}</label>
      <div class="col">
        <input
          class="full-width"
          id="callerName"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetCallLogPII?.getCallerName() }}"
        />
      </div>
    </div>

    <!-- Caller Type -->
    <div class="field grid">
      <label for="callerType" style="width: 200px">{{ t('callerTypeLabel') }}</label>
      <div class="col">
        <input
          class="full-width"
          id="callerType"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetCallLogPII?.getCallerType() }}"
        />
      </div>
    </div>

    <!-- Carrier Name -->
    <div class="field grid">
      <label for="carrierName" style="width: 200px">{{ t('carrierNameLabel') }}</label>
      <div class="col">
        <input
          class="full-width"
          id="carrierName"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetCallLogPII?.getCarrierName() }}"
        />
      </div>
    </div>

    <!-- Carrier Type -->
    <div class="field grid">
      <label for="carrierType" style="width: 200px">{{ t('carrierTypeLabel') }}</label>
      <div class="col">
        <input
          class="full-width"
          id="carrierType"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetCallLogPII?.getCarrierType() }}"
        />
      </div>
    </div>

    <!-- Country Code -->
    <div class="field grid">
      <label for="countryCode" style="width: 200px">{{ t('countryCodeLabel') }}</label>
      <div class="col">
        <input
          class="full-width"
          id="countryCode"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetCallLogPII?.getISO3166Alpha2CountryCode() }}"
        />
      </div>
    </div>

    <!-- Spoofing Warning -->
    <div class="field grid">
      <p *ngIf="communicationsResponseGetCallLogPII?.getShakenPassport() === undefined">{{ t('stirShakenMissing') }}</p>
    </div>
  </div>

  <div>
    <div class="row">
      <div *ngIf="!loading" class="col flex justify-content-start align-items-end flex-wrap">
        {{ t('dialogFooter', { dataRetentionEnd: dataRetentionEndFormatted }) }}
      </div>
      <div class="col flex justify-content-end flex-wrap">
        <p-button
          icon="pi pi-check"
          styleClass="p-button-text"
          label="{{ t('closeButtonLabel') }}"
          (click)="closeDialog()"
        ></p-button>
      </div>
    </div>
  </div>
</ng-container>
